// types
import { SplitPayData } from "@swiggy-private/payment-ui";
// helpers
import { CroutonState, SplitPayMethodValues } from "@payment-client/interfaces/SplitPay";
import { getSplitpayIdentifier } from "@swiggy-private/payment-ui";
import { format, isEmpty } from "@swiggy-private/js-utils";
// constants
import { ICONS, TEXTS, TIME_INTERVALS } from "@payment-client/hooks/constants";
import { SWIGGY_MONEY_OR_REWARDS_TOAST_MAX_COUNT } from "@payment-client/constants/Splitpay";
import { VALID_PAYMENT_METHODS } from "@swiggy-private/payment-types";

export const getSelectedSplitPayMethods = (splitPayList?: SplitPayData[], defaultValue = "") =>
    splitPayList
        ?.filter((method) => method?.select)
        ?.map((method) => getSplitpayIdentifier(method)) // [TODO] Remove paymentcode completely after twid 100% rollout
        ?.toString() || defaultValue;

export const getSelectedSplitpayMethodData = (splitpayList: SplitPayData[]) => {
    return splitpayList?.find((method) => method.select);
};

export const isAnySplitPayMethodEnabled = (splitPayList?: SplitPayData[]) =>
    splitPayList?.some((item) => item?.enabled);

export const isAnySplitPayMethodApplicableWithCoupon = (splitPayList?: SplitPayData[]): boolean =>
    splitPayList?.some((item) => item?.couponApplicable) || false;

export const isAnySplitPayMethodApplicableWithReward = (splitPayList?: SplitPayData[]): boolean =>
    splitPayList?.some((item) => item?.rewardApplicable) || false;

/**
 *
 * @param splitpayMethods comma separated list of splitpay methods - ex - "SwiggyPay,TwidRewards"
 * @returns array of splitpaymethods split by comma - ex - ["SwiggyPay", "TwidRewards"]
 */
export const getSplitpayMethodsNameAsArray = (splitpayMethods: string): string[] =>
    splitpayMethods.split(",").filter((s) => !isEmpty(s));

/**
 *
 * @param selectedMethods comma separated list of splitpay methods
 * @param splitpayList list of all splitpay methods
 * @returns true if any one of the selected splitpay method is a reward else false
 */
export const isSplitpayMethodReward = (selectedMethods: string, splitpayList?: SplitPayData[]) => {
    const selectMethodsArr = selectedMethods.split(",");

    const selectedMethodData = splitpayList?.find(
        (method) =>
            (selectMethodsArr.includes(method.paymentCode) || selectMethodsArr.includes(method.splitPayIdentifier)) &&
            method.isReward,
    );

    return Boolean(selectedMethodData?.isReward);
};

export const getCroutonState = ({
    methodData,
    selectedSplitPayMethods,
    splitpayList,
    showOneSplitPayToastCount,
    isSplitpaySelected,
}: {
    methodData: SplitPayData;
    selectedSplitPayMethods: string;
    splitpayList: SplitPayData[];
    showOneSplitPayToastCount: number;
    isSplitpaySelected: boolean;
}): { state: CroutonState; increaseOneSplitpayToastCount: boolean } | undefined => {
    const isPrevSelectedMethodReward = isSplitpayMethodReward(selectedSplitPayMethods, splitpayList);
    const isPrevSelectedMethodEmpty =
        isEmpty(selectedSplitPayMethods) || selectedSplitPayMethods === SplitPayMethodValues.DEFAULT;
    const isSelectedMethodReward = methodData.isReward;

    // if any splitpay method was not selected before [[AND]]
    // if prev selected splitpay was reward and now selected is not reward [[OR]] is prev selected was not a reward but now selected is a reward [[AND]]
    // if this toast is not already shown 3 times [[THEN]]
    // show that YOU CAN USE EITHER SM OR REWARD toast
    if (
        !isPrevSelectedMethodEmpty &&
        isPrevSelectedMethodReward !== isSelectedMethodReward &&
        showOneSplitPayToastCount < SWIGGY_MONEY_OR_REWARDS_TOAST_MAX_COUNT
    ) {
        return {
            state: {
                title: TEXTS.YOU_CAN_USE_EITHER_SWIGGY_MONEY_OR_REWARDS,
                durationOfCrouton: TIME_INTERVALS.SPLITPAY_CROUTON_DISPLAY_TIME,
                icon: ICONS.INFO_WHITE_ICON,
            },
            increaseOneSplitpayToastCount: true,
        };
    } else if (isSelectedMethodReward && isSplitpaySelected) {
        return {
            state: {
                title: format(TEXTS.YAY_XX_SAVED_WITH_YY_REWARDS, methodData.eligibleBalance, methodData.displayName),
                durationOfCrouton: TIME_INTERVALS.SPLITPAY_CROUTON_DISPLAY_TIME,
                icon: ICONS.SPARKLE_WHITE_ICON,
            },
            increaseOneSplitpayToastCount: false,
        };
    }
};

export const isSplitPayMethodMMT = (method: SplitPayData): boolean =>
    method.paymentCode?.toUpperCase() === VALID_PAYMENT_METHODS.MMT;
